//let DbFunctions = require('./dbfunctions').DbFunctions
let okeResponse = require('okeoke.standardresponse')
let moment = require('moment')
let { UUID } = require("uuidjs")
import { storeShift, getUnsyncedShifts, getLastShift, cleanupShifts } from '../../IDB/shifts'
import ordereduuid from '../../Helpers/timeuuid'

let Shifts = function (clientSocket, client) {
  const uid = UUID.generate()
  let currentShift = null

  const callbacks = {
    onShiftUpdated: {},
    onShiftStarted: {},
    onShiftEnded: {},
    onShiftsInited: {}
  }

  function addCallback(cbName, name, func) {
    try {
      callbacks[cbName][name] = func
    } catch (e) {
      console.error('Invalid callback name in - add (Orders)', cbName)
    }
  }

  function removeCallback(cbName, name) {
    try {
      delete callbacks[cbName][name]
    } catch (e) {
      console.error('Invalid callback name in - remove (Orders)', cbName)
    }
  }

  function callCallbacks(cbName, message) {
    if (callbacks[cbName] == null) return
    for (let callback of Object.values(callbacks[cbName] || {})) {
      if (typeof callback === 'function') {
        try {
          callback(message)
        } catch (e) {
          console.error(e)
        }
      }
    }
  }

  async function getLastSyncedShift() {
    return new Promise((resolve, reject) => {
      if (clientSocket.authorized) {
        setTimeout(() => {
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit('lastShift', {}, (e) => {
          resolve(e)
        })
      } else {
        resolve({ success: false, message: 'No connection to server!' })
      }
    })
  }

  async function syncShift(shift) {
    return new Promise((resolve, reject) => {
      if (!clientSocket.authorized) {
        shift.syncneeded = 1
        storeShift(shift)
        resolve({ success: false, message: 'Client not connected!' })
      } else {
        let done = false
        setTimeout(() => {
          if (!done) {
            shift.syncneeded = 1
            storeShift(shift)
          }
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit(
          'syncShift',
          {
            shift
          },
          (e) => {
            done = true
            if (!e.success) {
              shift.syncneeded = 1
              storeShift(shift)
            } else {
              shift.syncneeded = 0
              storeShift(shift)
            }
            resolve(e)
          }
        )
      }
    })
  }

  async function startShift(payments = []) {
    if (!client.localUser?.userUUID) return okeResponse(false, 400, 'No user logged in', { errMsgCode: 'shift.start.notloggedin' })
    if (currentShift == null || currentShift.shiftEnd != null) {
      let newShift = {
        uuid: ordereduuid(),
        shiftStart: new Date().getTime(),
        shiftEnd: null,
        startUserUUID: client.localUser?.userUUID,
        syncneeded: 0
      }
      currentShift = newShift
      callCallbacks('onShiftStarted', newShift)
      let docRes = await client.documents.addDocument(newShift.uuid, 1, null, null, null, [], payments)
      await syncShift(newShift)
      return okeResponse(true, 201, 'Inserted', { ...newShift, documentUUID: docRes.data.uuid })
    } else {
      return okeResponse(false, 400, 'Shift already started', null)
    }
  }

  async function endShift() {
    if (!client.localUser?.userUUID) return okeResponse(false, 400, 'No user logged in', { errMsgCode: 'shift.end.notloggedin' })
    if (currentShift != null && currentShift.shiftEnd == null) {
      currentShift.shiftEnd = new Date().getTime()
      currentShift.endUserUUID = client.localUser?.userUUID,
        callCallbacks('onShiftEnded', currentShift)
      let docRes = await client.documents.addDocument(currentShift.uuid, 2, null, null, null, [], [])
      await syncShift(currentShift)
      return okeResponse(true, 201, 'Inserted', { ...currentShift, documentUUID: docRes.data.uuid })
    } else {
      return okeResponse(false, 400, 'Shift not started', null)
    }
  }

  async function getShiftSums(shiftUUID) {
    let documents = await client.documents.getShiftDocuments(shiftUUID)
    // System
    let openTime = null
    let closeTime = null

    // Total
    let sum = 0
    let agentTypes = {}
    let agentIDs = {}
    let agentTree = {}

    // Sale
    let saleAgentTypes = {}
    let saleAgentIDs = {}
    let saleAgentTree = {}
    // Payin
    let payInByReason = {}
    let payInAgentTypes = {}
    let payInAgentIDs = {}
    let payInAgentTree = {}

    let payOutByReason = {}
    let payOutAgentTypes = {}
    let payOutAgentIDs = {}
    let payOutAgentTree = {}

    let receiptCount = 0
    let stornoCount = 0

    // From items
    let registerSums = {}
    let vatSums = {}
    let vatSumsByItemTypes = {}
    let itemTypeSums = {}

    let itemSums = {}
    let itemCounts = {}
    let itemQuantities = {}

    let itemStornoSums = {}
    let itemStornoCounts = {}
    let itemStornoQuantities = {}

    let itemSum = 0
    let itemDiscountSum = 0

    let itemStornoSum = 0
    let itemStornoDiscountSum = 0

    for (let document of documents.data) {
      if(document.documentType === 10) receiptCount++
      if(document.documentType === 11) stornoCount++
      if ([10, 11].includes(document.documentType)) {
        for (let trx of document.transactions || []) {
          // Total
          sum += parseFloat(trx.amount)
          agentTypes[trx.agentType] = (agentTypes[trx.agentType] || 0) + parseFloat(trx.amount)
          agentIDs[trx.agentID] = (agentIDs[trx.agentID] || 0) + parseFloat(trx.amount)
          if (!agentTree[trx.agentType]) agentTree[trx.agentType] = {}
          agentTree[trx.agentType][trx.agentID] = (agentTree[trx.agentType][trx.agentID] || 0) + parseFloat(trx.amount)

          // Sale
          saleAgentTypes[trx.agentType] = (saleAgentTypes[trx.agentType] || 0) + parseFloat(trx.amount)
          saleAgentIDs[trx.agentID] = (saleAgentIDs[trx.agentID] || 0) + parseFloat(trx.amount)
          if (!saleAgentTree[trx.agentType]) saleAgentTree[trx.agentType] = {}
          saleAgentTree[trx.agentType][trx.agentID] = (saleAgentTree[trx.agentType][trx.agentID] || 0) + parseFloat(trx.amount)
        }
        for (let item of document.items || []) {
          let itemDiscountPrice = parseFloat(item.discountPrice) * +item.count
          let itemPrice = parseFloat(item.price) * +item.count
          let itemVat = (+item.vat || 0).toFixed(2)
          registerSums[item.vatRegister] = (registerSums[item.vatRegister] || 0) + itemDiscountPrice
          itemTypeSums[item.type] = (itemTypeSums[item.type] || 0) + itemDiscountPrice
          vatSums[itemVat] = (vatSums[itemVat] || 0) + itemDiscountPrice
          if (!vatSumsByItemTypes[item.type]) vatSumsByItemTypes[item.type] = {}
          vatSumsByItemTypes[item.type][itemVat] = (vatSumsByItemTypes[item.type][itemVat] || 0) + itemDiscountPrice

          if (document.documentType === 10) {
            itemSums[item.name] = (itemSums[item.name] || 0) + itemDiscountPrice
            itemCounts[item.name] = (itemCounts[item.name] || 0) + +item.count
            itemQuantities[item.name] = (itemQuantities[item.name] || 0) + parseFloat(item.quantity)
            itemSum += itemPrice
            itemDiscountSum += itemDiscountPrice
          } else {
            itemStornoSums[item.name] = (itemStornoSums[item.name] || 0) + itemDiscountPrice
            itemStornoCounts[item.name] = (itemStornoCounts[item.name] || 0) + +item.count
            itemStornoQuantities[item.name] = (itemStornoQuantities[item.name] || 0) + parseFloat(item.quantity)
            itemStornoSum += itemPrice
            itemStornoDiscountSum += itemDiscountPrice
          }


        }
      }
      if (document.documentType === 1) {
        openTime = document.createTimestamp
        for (let trx of document.transactions || []) {
          let trxAmount = parseFloat(trx.amount)
          // Total
          sum += trxAmount
          agentTypes[trx.agentType] = (agentTypes[trx.agentType] || 0) + trxAmount
          agentIDs[trx.agentID] = (agentIDs[trx.agentID] || 0) + trxAmount
          // PayIn
          payInByReason[0] = (payInByReason[0] || 0) + trxAmount
          payInAgentTypes[trx.agentType] = (payInAgentTypes[trx.agentType] || 0) + trxAmount
          payInAgentIDs[trx.agentID] = (payInAgentIDs[trx.agentID] || 0) + trxAmount
          if (!payInAgentTree[trx.agentType]) payInAgentTree[trx.agentType] = {}
          payInAgentTree[trx.agentType][trx.agentID] = (payInAgentTree[trx.agentType][trx.agentID] || 0) + parseFloat(trx.amount)
        }
      }
      if (document.documentType === 2) {
        closeTime = document.createTimestamp
        for (let trx of document.transactions || []) {
          let trxAmount = parseFloat(trx.amount)
          // Total
          sum += trxAmount
          agentTypes[trx.agentType] = (agentTypes[trx.agentType] || 0) + trxAmount
          agentIDs[trx.agentID] = (agentIDs[trx.agentID] || 0) + trxAmount
          // PayOut
          payOutByReason[0] = (payOutByReason[0] || 0) + trxAmount
          payOutAgentTypes[trx.agentType] = (payOutAgentTypes[trx.agentType] || 0) + trxAmount
          payOutAgentIDs[trx.agentID] = (payOutAgentIDs[trx.agentID] || 0) + trxAmount
          if (!payOutAgentTree[trx.agentType]) payOutAgentTree[trx.agentType] = {}
          payOutAgentTree[trx.agentType][trx.agentID] = (payOutAgentTree[trx.agentType][trx.agentID] || 0) + parseFloat(trx.amount)
        }
      }
      if (document.documentType === 20) {
        for (let trx of document.transactions || []) {
          // Total
          sum += parseFloat(trx.amount)
          agentTypes[trx.agentType] = (agentTypes[trx.agentType] || 0) + parseFloat(trx.amount)
          agentIDs[trx.agentID] = (agentIDs[trx.agentID] || 0) + parseFloat(trx.amount)
          // PayIn
          payInByReason[document.reasonID] = (payInByReason[document.reasonID] || 0) + parseFloat(trx.amount)
          payInAgentTypes[trx.agentType] = (payInAgentTypes[trx.agentType] || 0) + parseFloat(trx.amount)
          payInAgentIDs[trx.agentID] = (payInAgentIDs[trx.agentID] || 0) + parseFloat(trx.amount)
          if (!payInAgentTree[trx.agentType]) payInAgentTree[trx.agentType] = {}
          payInAgentTree[trx.agentType][trx.agentID] = (payInAgentTree[trx.agentType][trx.agentID] || 0) + parseFloat(trx.amount)
        }
      }
      if (document.documentType === 21) {
        for (let trx of document.transactions || []) {
          // Total
          sum += parseFloat(trx.amount)
          agentTypes[trx.agentType] = (agentTypes[trx.agentType] || 0) + parseFloat(trx.amount)
          agentIDs[trx.agentID] = (agentIDs[trx.agentID] || 0) + parseFloat(trx.amount)
          // PayOut
          payOutByReason[document.reasonID] = (payOutByReason[document.reasonID] || 0) + parseFloat(trx.amount)
          payOutAgentTypes[trx.agentType] = (payOutAgentTypes[trx.agentType] || 0) + parseFloat(trx.amount)
          payOutAgentIDs[trx.agentID] = (payOutAgentIDs[trx.agentID] || 0) + parseFloat(trx.amount)
          if (!payOutAgentTree[trx.agentType]) payOutAgentTree[trx.agentType] = {}
          payOutAgentTree[trx.agentType][trx.agentID] = (payOutAgentTree[trx.agentType][trx.agentID] || 0) + parseFloat(trx.amount)
        }
      }
    }
    return okeResponse(true, 200, 'Success', {
      sum, agentTypes, agentIDs, agentTree, saleAgentTypes, saleAgentIDs, saleAgentTree, registerSums, itemTypeSums, vatSums,
      itemSums, itemCounts, itemQuantities, itemSum, itemDiscountSum, payInByReason,
      itemStornoSums, itemStornoCounts, itemStornoQuantities, itemStornoSum, itemStornoDiscountSum,
      payInAgentTypes, payInAgentIDs, payInAgentTree, payOutByReason, payOutAgentTypes, payOutAgentIDs, payOutAgentTree, vatSumsByItemTypes,
      openTime, closeTime, receiptCount, stornoCount
    })
  }

  async function syncOffline() {
    let shifts = await getUnsyncedShifts()
    for await (let shift of shifts) {
      await syncShift(shift)
    }
  }

  function onConnectionChange(data) {
    switch (data.state) {
      case 'Authorized':
        if (currentShift == null) {
          getLastSyncedShift().then((res) => {
            if (res.success) {
              storeShift(res.data)
              currentShift = res.data
              callCallbacks('onShiftUpdated', currentShift)
            } else {
              //startShift()
            }
          })
        }
        syncOffline()
        break
      default:
        break
    }
  }

  function init() {
    if (!client.offlineEnabled) return
    let connected = clientSocket.authorized
    clientSocket.addCallback('onConnectionChange', uid, onConnectionChange)
    getLastShift().then((shift) => {
      if (shift) {
        currentShift = shift
        callCallbacks('onShiftUpdated', shift)
        callCallbacks('onShiftsInited', shift)
        cleanupShifts(shift.uuid)
      } else {
        if (connected && currentShift == null) {
          getLastSyncedShift().then((res) => {
            if (res.success) {
              currentShift = res.data
              storeShift(currentShift)
              callCallbacks('onShiftUpdated', currentShift)
              callCallbacks('onShiftsInited', currentShift)
              cleanupShifts(currentShift.uuid)
            } else {
              callCallbacks('onShiftsInited', null)
              cleanupShifts('')
            }
          })
        }
      }
    })
  }

  return {
    startShift,
    endShift,
    getShiftSums,
    init,
    addCallback,
    removeCallback
  }
}

export { Shifts }